import { css, CSSObject, SerializedStyles } from '@emotion/react';
import {
    HoneycombTheme,
    createResponsiveStyles,
    mergeResponsiveStyleValues,
    useHoneycombTheme,
    ResponsiveStyleValue,
    HoneycombShadowSize,
    HoneycombRadius,
} from '../../theming';
import { isHoneycombRadius } from '../../utils';

// Static styles
export const PAPER_STATIC_STYLES: SerializedStyles = css`
    --paper-radius: var(--hc-radius-m);
    --paper-shadow: none;
    --paper-border-width: 1px;

    outline: 0;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    display: block;
    touch-action: manipulation;
    box-shadow: var(--paper-shadow);
    background-color: var(--hc-color-background-content);
    border-radius: var(--paper-radius);
    border: var(--paper-border-width) solid var(--hc-color-border);
`;

function getResponsiveVariables(theme: HoneycombTheme) {
    return (value: { shadow: HoneycombShadowSize; radius: HoneycombRadius }): CSSObject => {
        const { radius, shadow } = value;
        const shadowValue = theme.shadows[shadow];
        return {
            '--paper-radius': isHoneycombRadius(radius) ? `var(--hc-radius-${radius})` : radius,
            '--paper-shadow': shadowValue ?? undefined,
        };
    };
}

export function usePaperCssVariables(border: number): React.CSSProperties {
    return {
        '--paper-border-width': `${border}px`,
    } as React.CSSProperties;
}

export function usePaperDynamicStyles(
    shadow: ResponsiveStyleValue<HoneycombShadowSize>,
    radius: ResponsiveStyleValue<HoneycombRadius | string>
): CSSObject {
    const { theme } = useHoneycombTheme();
    return {
        ...createResponsiveStyles(
            [
                {
                    value: mergeResponsiveStyleValues({ shadow, radius }, theme),
                    getStyles: getResponsiveVariables(theme),
                },
            ],
            theme
        ),
    };
}
